/**
 * Header 컴포넌트
 * @description 화면 위쪽 줄의 **껍데기**. 시안 `3.0/shell/header` — 여백 · 간격 · 정렬만
 *   책임지고 무엇이 놓일지는 모른다. 시안도 껍데기 하나에 슬롯(`.3.0/slot/header/*`)을
 *   갈아 끼우는 구조다. 슬롯은 각자의 도메인이 갖는다. 앱 `shared/ui/Header` 의 웹 포팅.
 * @example
 * <Header title="Agreement" onBack={back} />
 * <Header inset='tab'><DiscoveryHeaderSlot /></Header>
 */
import { memo } from "react";

import { headerStyles } from "./Header.styles";
import type { HeaderProps } from "./Header.types";
import HeaderBrowseSlot from "./HeaderBrowseSlot";

const Header = memo<HeaderProps>(
  ({
    children,
    title,
    titleTrailing,
    onBack,
    leadingGhost = false,
    trailingGhost = false,
    following,
    backAccessibilityLabel,
    inset = "screen",
    testID,
  }) => (
    <header
      className={headerStyles.root({
        inset,
        hasBack: Boolean(onBack) || leadingGhost,
        trailingGhost,
      })}
      data-testid={testID}
    >
      {children ?? (
        <HeaderBrowseSlot
          title={title}
          titleTrailing={titleTrailing}
          onBack={onBack}
          following={following}
          backAccessibilityLabel={backAccessibilityLabel}
        />
      )}
    </header>
  ),
);

Header.displayName = "Header";

export default Header;
